import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=8edff4d6&scoped=true&"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js&"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNavigation.vue?vue&type=style&index=0&id=8edff4d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edff4d6",
  null
  
)

export default component.exports